import React from 'react';
import { User } from 'lucide-react';

export const defaultMentorQuestions = [
  {

    id: 'avatar',
    mandatory: false,
    placeholder: 'avatar',
    title: 'uploadAvatar',
    type: 'avatar',
    image: <User size={60} className='file-icon' />,
  },
  {
    id: 'headline',
    mandatory: true,
    placeholder: 'headline',
    title: 'headline',
    type: 'textarea',
  },
  {
    id: 'company',
    mandatory: false,
    placeholder: 'company',
    title: 'company',
    type: 'text',
  },
  {
    id: 'country',
    mandatory: false,
    placeholder: 'country',
    title: 'country',
    type: 'select',
    answers: ['ARG', 'BEL', 'BRA', 'COL', 'DEU', 'FRA', 'GBR', 'ITA', 'ESP', 'USA'],
  },
  {

    id: 'hours',
    mandatory: false,
    placeholder: 'hours',
    title: 'hoursToDonate',
    type: 'number',
    min: 0,
    max: 99999,
  },
  {
    id: 'visible',
    mandatory: false,
    placeholder: 'visible',
    title: 'mentorVisible',
    type: 'select',
    answers: [
      { order: 0, text: { es: 'yes', en: 'yes' }, id: true },
      { order: 1, text: { es: 'no', en: 'no' }, id: false },
    ],
  },
];
